(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cowboy-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedKey = '__collectionCowboyTallyPopupInitialized';
    const loaderKey = '__collectionCowboyTallyLoader';
    const activePopupKey = '__collectionCowboyActiveTallyPopup';
    const scriptUrl = 'https://tally.so/widgets/embed.js';

    if (window[initializedKey]) return;
    window[initializedKey] = true;

    const openingTriggers = new WeakSet();

    const getTallyFormId = (value) => {
      if (!value) return null;

      try {
        const url = new URL(value, document.baseURI);
        const hostname = url.hostname.toLowerCase();

        if (hostname !== 'tally.so' && !hostname.endsWith('.tally.so')) return null;

        const pathParts = url.pathname.split('/').filter(Boolean);
        const markerIndex = pathParts.findIndex((part) => ['r', 'embed', 'forms'].includes(part.toLowerCase()));
        const formId = markerIndex >= 0 ? pathParts[markerIndex + 1] : '';

        return formId && /^[a-z0-9_-]+$/i.test(formId) ? formId : null;
      } catch (error) {
        return null;
      }
    };

    const loadTally = () => {
      if (window.Tally && typeof window.Tally.openPopup === 'function') {
        return Promise.resolve(window.Tally);
      }

      if (window[loaderKey]) return window[loaderKey];

      window[loaderKey] = new Promise((resolve, reject) => {
        let settled = false;
        let script = document.querySelector(`script[src="${scriptUrl}"]`);
        let shouldAppendScript = false;

        const finish = () => {
          if (settled) return;

          if (window.Tally && typeof window.Tally.openPopup === 'function') {
            settled = true;
            resolve(window.Tally);
          }
        };

        const fail = () => {
          if (settled) return;
          settled = true;
          reject(new Error('The Tally popup script could not be loaded.'));
        };

        if (!script) {
          script = document.createElement('script');
          script.src = scriptUrl;
          script.async = true;
          shouldAppendScript = true;
        }

        script.addEventListener('load', finish, { once: true });
        script.addEventListener('error', fail, { once: true });

        if (shouldAppendScript) {
          document.head.appendChild(script);
        }

        window.setTimeout(() => {
          finish();
          if (!settled) fail();
        }, 10000);
      }).catch((error) => {
        window[loaderKey] = null;
        throw error;
      });

      return window[loaderKey];
    };

    const followLinkFallback = (trigger) => {
      if (!trigger.href) return;

      if (trigger.target === '_blank') {
        const fallbackWindow = window.open('', '_blank');

        if (fallbackWindow) {
          fallbackWindow.opener = null;
          fallbackWindow.location = trigger.href;
          return;
        }
      }

      window.location.assign(trigger.href);
    };

    document.addEventListener('click', async (event) => {
      if (
        (event.defaultPrevented && !window.Shopify?.designMode) ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        !(event.target instanceof Element)
      ) {
        return;
      }

      const trigger = event.target.closest('[data-collection-cowboy-tally-popup]');
      if (!trigger) return;

      const formId = getTallyFormId(trigger.dataset.tallyUrl || trigger.href);
      if (!formId) return;

      event.preventDefault();

      if (openingTriggers.has(trigger) || window[activePopupKey]?.trigger === trigger) return;
      openingTriggers.add(trigger);

      try {
        const Tally = await loadTally();
        const requestedWidth = Number.parseInt(trigger.dataset.tallyWidth, 10);
        const width = Number.isFinite(requestedWidth) ? Math.min(1000, Math.max(400, requestedWidth)) : 800;

        window[activePopupKey] = { formId, trigger };

        Tally.openPopup(formId, {
          layout: 'modal',
          width,
          overlay: true,
          hideTitle: trigger.dataset.tallyHideTitle === 'true',
          onOpen: () => {
            trigger.setAttribute('aria-expanded', 'true');
          },
          onClose: () => {
            trigger.setAttribute('aria-expanded', 'false');

            if (trigger.isConnected) {
              trigger.focus({ preventScroll: true });
            }

            if (window[activePopupKey]?.trigger === trigger) {
              window[activePopupKey] = null;
            }
          },
        });
      } catch (error) {
        if (window[activePopupKey]?.trigger === trigger) {
          window[activePopupKey] = null;
        }

        followLinkFallback(trigger);
      } finally {
        openingTriggers.delete(trigger);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const activePopup = window[activePopupKey];

      if (
        activePopup?.trigger &&
        event.target instanceof Element &&
        event.target.contains(activePopup.trigger) &&
        window.Tally &&
        typeof window.Tally.closePopup === 'function'
      ) {
        window.Tally.closePopup(activePopup.formId);
        window[activePopupKey] = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mb-hero-video-sound')) {
    customElements.define('mb-hero-video-sound', class extends HTMLElement {
      connectedCallback() {
        this.stopWaitingForMarkup();
        if (this.initialize()) return;

        // Shopify can connect the element before its button has been parsed.
        this.markupObserver = new MutationObserver(() => {
          if (this.initialize()) this.stopWaitingForMarkup();
        });
        this.markupObserver.observe(this.parentElement, { childList: true, subtree: true });
      }

      stopWaitingForMarkup() {
        if (this.markupObserver) this.markupObserver.disconnect();
        this.markupObserver = null;
      }

      initialize() {
        if (!this.isConnected) return false;
        if (this.abortController) return true;

        this.video = this.parentElement.querySelector('video.hero__video');
        this.button = this.querySelector('.hero__video-sound-button');
        if (!this.video || !this.button) return false;

        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.video.defaultMuted = true;
        this.video.muted = true;

        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const unmute = this.video.muted || this.video.volume === 0;
          this.video.muted = !unmute;
          if (unmute) {
            if (this.video.volume === 0) this.video.volume = 1;
            const video = this.video;
            const playback = video.play();
            if (playback) {
              playback.catch(() => {
                if (options.signal.aborted || !this.isConnected) return;
                video.muted = true;
                this.updateButton();
              });
            }
          }
          this.updateButton();
        }, options);

        this.video.addEventListener('volumechange', () => this.updateButton(), options);

        // A video hidden by the desktop/mobile switch must not keep playing audio.
        this.breakpoint = window.matchMedia('(max-width: 749px)');
        this.breakpoint.addEventListener('change', () => {
          if (!this.video.getClientRects().length) this.video.muted = true;
          this.updateButton();
        }, options);

        this.updateButton();
        this.button.hidden = false;
        return true;
      }

      updateButton() {
        const muted = this.video.muted || this.video.volume === 0;
        const label = muted ? 'Unmute video' : 'Mute video';
        this.dataset.muted = String(muted);
        this.button.setAttribute('aria-label', label);
        this.button.title = label;
      }

      disconnectedCallback() {
        this.stopWaitingForMarkup();
        if (this.video) this.video.muted = true;
        if (this.button) this.button.hidden = true;
        if (this.abortController) this.abortController.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maya-shop-by-category"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class MayaCategorySlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.categorySliderInitialized === 'true') return;

        this.dataset.categorySliderInitialized = 'true';
        this.shell = this.querySelector('[data-category-slider-shell]');
        this.scroller = this.querySelector('[data-category-scroller]');
        this.controls = this.querySelector('[data-category-controls]');
        this.previousButton = this.querySelector('[data-category-previous]');
        this.nextButton = this.querySelector('[data-category-next]');

        this.initializeGlassReflections();
        this.initializeCtaScrollMotion();

        if (!this.shell || !this.scroller || !this.controls || !this.previousButton || !this.nextButton) return;

        this.handleScroll = (event) => {
          if (event?.currentTarget === this.scroller) {
            this.handleCtaHorizontalScroll?.();
          } else if (event?.type === 'resize') {
            this.handleCtaMotionLayoutChange?.();
          }

          window.requestAnimationFrame(() => this.updateControls());
          this.requestGlassReflectionUpdate?.();
        };
        this.handlePrevious = () => this.scrollByCard(-1);
        this.handleNext = () => this.scrollByCard(1);

        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            this.handleCtaMotionLayoutChange?.();
            this.updateControls();
          });
          this.resizeObserver.observe(this.scroller);
        } else {
          window.addEventListener('resize', this.handleScroll);
        }

        window.requestAnimationFrame(() => this.updateControls());
      }

      disconnectedCallback() {
        this.cleanupCtaScrollMotion();
        this.cleanupGlassReflections();

        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.scroller?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.handleScroll);
        delete this.dataset.categorySliderInitialized;
      }

      initializeGlassReflections() {
        this.glassSurfaces = Array.from(
          this.querySelectorAll('.mb-shop-by-category__arrow')
        );
        this.glassMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.glassReflectionFrame = undefined;

        this.resetGlassReflections = () => {
          this.glassSurfaces.forEach((surface) => {
            surface.style.removeProperty('--mb-glass-x');
            surface.style.removeProperty('--mb-glass-y');
          });
        };

        this.updateGlassReflections = () => {
          this.glassReflectionFrame = undefined;

          const viewportWidth = Math.max(document.documentElement.clientWidth, 1);
          const viewportHeight = Math.max(document.documentElement.clientHeight, 1);

          this.glassSurfaces.forEach((surface) => {
            const rectangle = surface.getBoundingClientRect();
            const isVisible =
              rectangle.width > 0 &&
              rectangle.height > 0 &&
              rectangle.bottom >= 0 &&
              rectangle.top <= viewportHeight &&
              rectangle.right >= 0 &&
              rectangle.left <= viewportWidth;

            if (!isVisible) return;

            const verticalPosition = Math.min(
              1,
              Math.max(0, (rectangle.top + rectangle.height / 2) / viewportHeight)
            );
            const horizontalPosition = Math.min(
              1,
              Math.max(0, (rectangle.left + rectangle.width / 2) / viewportWidth)
            );
            const reflectionX = Math.min(
              86,
              Math.max(14, 18 + horizontalPosition * 35 + (1 - verticalPosition) * 25)
            );
            const reflectionY = Math.min(115, Math.max(-15, 110 - verticalPosition * 120));

            surface.style.setProperty('--mb-glass-x', `${reflectionX.toFixed(2)}%`);
            surface.style.setProperty('--mb-glass-y', `${reflectionY.toFixed(2)}%`);
          });
        };

        this.requestGlassReflectionUpdate = (event) => {
          if (event?.type === 'scroll' && event.currentTarget === window) {
            this.handleCtaPageScroll?.();
          }

          if (this.glassMotionPreference.matches || this.glassReflectionFrame !== undefined) return;

          this.glassReflectionFrame = window.requestAnimationFrame(this.updateGlassReflections);
        };

        this.handleGlassMotionPreference = () => {
          if (this.glassMotionPreference.matches) {
            if (this.glassReflectionFrame !== undefined) {
              window.cancelAnimationFrame(this.glassReflectionFrame);
              this.glassReflectionFrame = undefined;
            }

            this.resetGlassReflections();
            return;
          }

          this.requestGlassReflectionUpdate();
        };

        window.addEventListener('scroll', this.requestGlassReflectionUpdate, { passive: true });
        window.addEventListener('resize', this.requestGlassReflectionUpdate);

        if (typeof this.glassMotionPreference.addEventListener === 'function') {
          this.glassMotionPreference.addEventListener('change', this.handleGlassMotionPreference);
        } else {
          this.glassMotionPreference.addListener(this.handleGlassMotionPreference);
        }

        this.requestGlassReflectionUpdate();
      }

      cleanupGlassReflections() {
        window.removeEventListener('scroll', this.requestGlassReflectionUpdate);
        window.removeEventListener('resize', this.requestGlassReflectionUpdate);

        if (typeof this.glassMotionPreference?.removeEventListener === 'function') {
          this.glassMotionPreference.removeEventListener('change', this.handleGlassMotionPreference);
        } else {
          this.glassMotionPreference?.removeListener(this.handleGlassMotionPreference);
        }

        if (this.glassReflectionFrame !== undefined) {
          window.cancelAnimationFrame(this.glassReflectionFrame);
          this.glassReflectionFrame = undefined;
        }

        this.resetGlassReflections?.();
        this.glassSurfaces = [];
      }

      initializeCtaScrollMotion() {
        this.ctaMotionElements = Array.from(this.querySelectorAll('[data-category-liquid-cta]'));
        this.ctaMotionControllers = new Map();
        this.ctaMotionProfiles = new Map();
        this.visibleCtaMotionElements = new Set();
        this.ctaMotionFrame = undefined;
        this.ctaMotionLastFrameTime = 0;
        this.ctaMotionLastInputTime = 0;
        this.ctaMotionPendingX = 0;
        this.ctaMotionPendingY = 0;
        this.ctaMotionHorizontalDirty = false;
        this.ctaMotionPathX = 0;
        this.ctaMotionPathY = 0;
        this.ctaMotionPathHistory = [];
        this.ctaMotionDestroyed = false;
        this.ctaMotionVisibilityReady = false;
        this.ctaMotionCoreRetryFrame = undefined;
        this.ctaMotionCoreRetryCount = 0;

        if (this.ctaMotionElements.length === 0) return;

        const clamp = (value, minimum, maximum) =>
          Math.max(minimum, Math.min(maximum, value));

        this.getCtaPageScrollY = () => {
          const maximumScroll = Math.max(
            0,
            document.documentElement.scrollHeight - window.innerHeight
          );
          const currentScroll = window.scrollY || window.pageYOffset || 0;
          return clamp(currentScroll, 0, maximumScroll);
        };

        this.getCtaScrollerContentX = () => {
          const referenceCard = this.scroller?.querySelector('.mb-shop-by-category__card');
          return referenceCard ? referenceCard.getBoundingClientRect().left : null;
        };

        this.ctaMotionLastScrollY = this.getCtaPageScrollY();
        this.ctaMotionLastScrollerX = this.getCtaScrollerContentX();

        const hashString = (value) => {
          let hash = 2166136261;

          for (let index = 0; index < value.length; index += 1) {
            hash ^= value.charCodeAt(index);
            hash = Math.imul(hash, 16777619);
          }

          return hash >>> 0;
        };

        const seededUnit = (seed, salt) => {
          let value = (seed ^ salt) >>> 0;
          value ^= value >>> 16;
          value = Math.imul(value, 0x7feb352d);
          value ^= value >>> 15;
          value = Math.imul(value, 0x846ca68b);
          value ^= value >>> 16;
          return (value >>> 0) / 4294967296;
        };

        const dropletTemplates = [
          { delayMs: 0, movementGain: 0.86, tempo: 1.2, dampingRatio: 0.38, angle: -7 },
          { delayMs: 16, movementGain: 1.16, tempo: 0.84, dampingRatio: 0.49, angle: 5 },
          { delayMs: 32, movementGain: 0.98, tempo: 1.08, dampingRatio: 0.42, angle: -3 },
          { delayMs: 48, movementGain: 1.08, tempo: 0.94, dampingRatio: 0.46, angle: 7 },
          { delayMs: 64, movementGain: 0.82, tempo: 1.14, dampingRatio: 0.36, angle: -5 },
          { delayMs: 80, movementGain: 1.2, tempo: 0.82, dampingRatio: 0.44, angle: 3 },
        ];
        const rankedDroplets = this.ctaMotionElements
          .map((element, index) => {
            const stableId = element.dataset.categoryLiquidId || `category-${index}`;
            return { element, seed: hashString(stableId) };
          })
          .sort((first, second) => first.seed - second.seed);
        const dropletAssignments = new Map();

        rankedDroplets.forEach((entry, rank) => {
          const spreadIndex =
            rankedDroplets.length > 1 && rankedDroplets.length <= dropletTemplates.length
              ? Math.round(
                  (rank * (dropletTemplates.length - 1)) / (rankedDroplets.length - 1)
                )
              : rank % dropletTemplates.length;
          dropletAssignments.set(entry.element, {
            template: dropletTemplates[spreadIndex],
            seed: entry.seed,
            cycle: Math.floor(rank / dropletTemplates.length),
          });
        });

        this.ensureCtaMotionProfile = (element) => {
          const existingProfile = this.ctaMotionProfiles.get(element);
          if (existingProfile) return existingProfile;

          const assignment = dropletAssignments.get(element) || {
            template: dropletTemplates[2],
            seed: 0,
            cycle: 0,
          };
          const template = assignment.template;
          const cycleStrength = assignment.cycle > 0 ? 1 : 0.35;
          const tempo = template.tempo *
            (1 + (seededUnit(assignment.seed, 0x9e3779b9) - 0.5) * 0.025 * cycleStrength);
          const movementGain = template.movementGain *
            (1 + (seededUnit(assignment.seed, 0x85ebca6b) - 0.5) * 0.03 * cycleStrength);
          const dampingRatio = clamp(
            template.dampingRatio +
              (seededUnit(assignment.seed, 0xc2b2ae35) - 0.5) * 0.015 * cycleStrength,
            0.35,
            0.5
          );
          const naturalFrequency = Math.sqrt(145) * tempo;
          const profile = {
            delayMs: clamp(
              template.delayMs +
                (seededUnit(assignment.seed, 0x165667b1) - 0.5) * 6 * cycleStrength,
              0,
              84
            ),
            movementGain,
            directionSkew:
              (template.angle +
                (seededUnit(assignment.seed, 0x27d4eb2f) - 0.5) * cycleStrength) *
              (Math.PI / 180),
            velocityFilterRate: 18 * tempo,
            speedReference: 3000 / movementGain,
            shapeStiffness: naturalFrequency * naturalFrequency,
            shapeDamping: 2 * dampingRatio * naturalFrequency,
            hasPathSample: false,
            lastPathX: 0,
            lastPathY: 0,
          };

          this.ctaMotionProfiles.set(element, profile);
          return profile;
        };

        this.sampleCtaMotionPath = (sampleTime) => {
          const history = this.ctaMotionPathHistory;

          if (history.length === 0) {
            return { x: this.ctaMotionPathX, y: this.ctaMotionPathY };
          }

          if (sampleTime <= history[0].time) {
            return { x: history[0].x, y: history[0].y };
          }

          const lastPoint = history[history.length - 1];
          if (sampleTime >= lastPoint.time) {
            return { x: lastPoint.x, y: lastPoint.y };
          }

          for (let index = 1; index < history.length; index += 1) {
            const nextPoint = history[index];
            if (sampleTime > nextPoint.time) continue;

            const previousPoint = history[index - 1];
            const span = Math.max(0.001, nextPoint.time - previousPoint.time);
            const progress = clamp((sampleTime - previousPoint.time) / span, 0, 1);
            return {
              x: previousPoint.x + (nextPoint.x - previousPoint.x) * progress,
              y: previousPoint.y + (nextPoint.y - previousPoint.y) * progress,
            };
          }

          return { x: lastPoint.x, y: lastPoint.y };
        };

        this.initializeCtaMotionPathSample = (element, now = performance.now()) => {
          const profile = this.ensureCtaMotionProfile(element);
          const sample = this.sampleCtaMotionPath(now - profile.delayMs);
          profile.lastPathX = sample.x;
          profile.lastPathY = sample.y;
          profile.hasPathSample = true;
        };

        this.clearCtaMotionInput = () => {
          this.ctaMotionPendingX = 0;
          this.ctaMotionPendingY = 0;
          this.ctaMotionHorizontalDirty = false;
          this.ctaMotionPathX = 0;
          this.ctaMotionPathY = 0;
          this.ctaMotionPathHistory = [];
          this.ctaMotionProfiles.forEach((profile, element) => {
            profile.hasPathSample = this.visibleCtaMotionElements.has(element);
            profile.lastPathX = 0;
            profile.lastPathY = 0;
          });
        };

        this.capCtaMotionPendingVector = () => {
          const magnitude = Math.hypot(this.ctaMotionPendingX, this.ctaMotionPendingY);
          if (magnitude <= 96 || magnitude === 0) return;

          const scale = 96 / magnitude;
          this.ctaMotionPendingX *= scale;
          this.ctaMotionPendingY *= scale;
        };

        this.resetCtaMotionElement = (element) => {
          this.ctaMotionControllers.get(element)?.reset();
          const profile = this.ctaMotionProfiles.get(element);
          if (profile) profile.hasPathSample = false;
          element.classList.remove('is-liquid-moving');
        };

        this.resetAllCtaScrollMotion = () => {
          if (this.ctaMotionFrame !== undefined) {
            window.cancelAnimationFrame(this.ctaMotionFrame);
            this.ctaMotionFrame = undefined;
          }

          this.clearCtaMotionInput();
          this.ctaMotionLastFrameTime = 0;
          this.ctaMotionLastInputTime = 0;
          this.ctaMotionLastScrollY = this.getCtaPageScrollY();
          this.ctaMotionLastScrollerX = this.getCtaScrollerContentX();
          this.ctaMotionControllers.forEach((controller, element) => {
            controller.reset();
            element.classList.remove('is-liquid-moving');
          });
        };

        this.ensureCtaMotionController = (element) => {
          const existingController = this.ctaMotionControllers.get(element);
          if (existingController) return existingController;

          const surface = element.querySelector('[data-category-liquid-surface]');
          if (!surface || !window.LTLiquidGlass?.createMotion) return null;

          const profile = this.ensureCtaMotionProfile(element);

          const controller = window.LTLiquidGlass.createMotion(element, {
            surface,
            reducedMotionQuery: this.glassMotionPreference,
            velocityFilterRate: profile.velocityFilterRate,
            speedReference: profile.speedReference,
            shapeStiffness: profile.shapeStiffness,
            shapeDamping: profile.shapeDamping,
          });

          this.ctaMotionControllers.set(element, controller);
          return controller;
        };

        this.runCtaScrollMotionFrame = (now) => {
          this.ctaMotionFrame = undefined;

          if (this.ctaMotionDestroyed || this.glassMotionPreference.matches) {
            this.resetAllCtaScrollMotion();
            return;
          }

          const elapsedSeconds = clamp(
            (now - (this.ctaMotionLastFrameTime || now - 1000 / 60)) / 1000,
            1 / 240,
            0.034
          );
          this.ctaMotionLastFrameTime = now;

          if (this.ctaMotionHorizontalDirty) {
            this.ctaMotionHorizontalDirty = false;
            const nextScrollerX = this.getCtaScrollerContentX();

            if (
              Number.isFinite(nextScrollerX) &&
              Number.isFinite(this.ctaMotionLastScrollerX)
            ) {
              const horizontalMovement = nextScrollerX - this.ctaMotionLastScrollerX;
              if (Math.abs(horizontalMovement) >= 0.15) {
                this.ctaMotionPendingX += horizontalMovement;
                this.ctaMotionLastInputTime = now;
              }
            }

            this.ctaMotionLastScrollerX = nextScrollerX;
          }

          this.capCtaMotionPendingVector();

          const maximumMovement = 2400 * elapsedSeconds;
          const pendingMagnitude = Math.hypot(
            this.ctaMotionPendingX,
            this.ctaMotionPendingY
          );
          const drainScale =
            pendingMagnitude > 0 ? Math.min(1, maximumMovement / pendingMagnitude) : 0;
          let movedX = this.ctaMotionPendingX * drainScale;
          let movedY = this.ctaMotionPendingY * drainScale;
          this.ctaMotionPendingX -= movedX;
          this.ctaMotionPendingY -= movedY;

          if (Math.hypot(movedX, movedY) < 0.15) {
            movedX = 0;
            movedY = 0;
            if (Math.abs(this.ctaMotionPendingX) < 0.15) this.ctaMotionPendingX = 0;
            if (Math.abs(this.ctaMotionPendingY) < 0.15) this.ctaMotionPendingY = 0;
          }

          const movementMagnitude = Math.hypot(movedX, movedY);
          if (movementMagnitude > 0) {
            if (this.ctaMotionPathHistory.length === 0) {
              this.ctaMotionPathHistory.push({
                time: now - elapsedSeconds * 1000,
                x: this.ctaMotionPathX,
                y: this.ctaMotionPathY,
              });
            }

            this.ctaMotionPathX += movedX;
            this.ctaMotionPathY += movedY;
            this.ctaMotionPathHistory.push({
              time: now,
              x: this.ctaMotionPathX,
              y: this.ctaMotionPathY,
            });

            if (this.ctaMotionPathHistory.length > 64) {
              this.ctaMotionPathHistory.splice(0, this.ctaMotionPathHistory.length - 64);
            }
          }

          let maximumVisibleDelay = 0;
          this.visibleCtaMotionElements.forEach((element) => {
            maximumVisibleDelay = Math.max(
              maximumVisibleDelay,
              this.ensureCtaMotionProfile(element).delayMs
            );
          });

          const pendingIsEmpty =
            Math.hypot(this.ctaMotionPendingX, this.ctaMotionPendingY) < 0.15;
          let allSettled =
            pendingIsEmpty &&
            !this.ctaMotionHorizontalDirty &&
            now - this.ctaMotionLastInputTime > 90 + maximumVisibleDelay;
          const lastPathPoint =
            this.ctaMotionPathHistory[this.ctaMotionPathHistory.length - 1];

          this.visibleCtaMotionElements.forEach((element) => {
            const controller = this.ensureCtaMotionController(element);
            const profile = this.ensureCtaMotionProfile(element);
            if (!controller) {
              allSettled = false;
              return;
            }

            const delayedSample = this.sampleCtaMotionPath(now - profile.delayMs);
            if (!profile.hasPathSample) {
              profile.lastPathX = delayedSample.x;
              profile.lastPathY = delayedSample.y;
              profile.hasPathSample = true;
            }

            const pathMovedX =
              (delayedSample.x - profile.lastPathX) * profile.movementGain;
            const pathMovedY =
              (delayedSample.y - profile.lastPathY) * profile.movementGain;
            profile.lastPathX = delayedSample.x;
            profile.lastPathY = delayedSample.y;

            const skewCosine = Math.cos(profile.directionSkew);
            const skewSine = Math.sin(profile.directionSkew);
            const localMovedX = pathMovedX * skewCosine - pathMovedY * skewSine;
            const localMovedY = pathMovedX * skewSine + pathMovedY * skewCosine;

            const localSpeed = Math.hypot(localMovedX, localMovedY) / elapsedSeconds;
            const caughtUp =
              !lastPathPoint || now >= lastPathPoint.time + profile.delayMs;
            const pointerIsIdle =
              pendingIsEmpty &&
              !this.ctaMotionHorizontalDirty &&
              caughtUp &&
              now - this.ctaMotionLastInputTime > 90 + profile.delayMs;

            element.classList.add('is-liquid-moving');
            const result = controller.update({
              elapsedSeconds,
              movedX: localMovedX,
              movedY: localMovedY,
              targetDistance: Math.min(88, localSpeed * 0.05),
              pointerIsIdle,
            });

            if (!caughtUp || !result.settled) allSettled = false;
          });

          if (allSettled) {
            this.visibleCtaMotionElements.forEach((element) => {
              this.resetCtaMotionElement(element);
            });
            this.ctaMotionLastFrameTime = 0;
            this.clearCtaMotionInput();
            return;
          }

          this.ctaMotionFrame = window.requestAnimationFrame(this.runCtaScrollMotionFrame);
        };

        this.requestCtaScrollMotionFrame = () => {
          if (
            this.ctaMotionDestroyed ||
            this.glassMotionPreference.matches ||
            this.visibleCtaMotionElements.size === 0 ||
            this.ctaMotionFrame !== undefined
          ) {
            return;
          }

          this.ctaMotionLastFrameTime = performance.now();
          this.ctaMotionFrame = window.requestAnimationFrame(this.runCtaScrollMotionFrame);
        };

        this.handleCtaPageScroll = () => {
          const nextScrollY = this.getCtaPageScrollY();
          const pageMovement = nextScrollY - this.ctaMotionLastScrollY;
          this.ctaMotionLastScrollY = nextScrollY;

          if (this.glassMotionPreference.matches || Math.abs(pageMovement) < 0.15) return;
          if (this.visibleCtaMotionElements.size === 0) {
            this.clearCtaMotionInput();
            return;
          }

          this.ctaMotionPendingY += -pageMovement;
          this.capCtaMotionPendingVector();
          this.ctaMotionLastInputTime = performance.now();
          this.requestCtaScrollMotionFrame();
        };

        this.handleCtaHorizontalScroll = () => {
          if (this.ctaMotionDestroyed || this.glassMotionPreference.matches) return;

          if (this.visibleCtaMotionElements.size === 0) {
            this.ctaMotionPendingX = 0;
            this.ctaMotionHorizontalDirty = false;
            this.ctaMotionLastScrollerX = this.getCtaScrollerContentX();
            return;
          }

          this.ctaMotionHorizontalDirty = true;
          this.requestCtaScrollMotionFrame();
        };

        this.handleCtaMotionLayoutChange = () => {
          this.ctaMotionPendingX = 0;
          this.ctaMotionHorizontalDirty = false;
          this.ctaMotionLastScrollerX = this.getCtaScrollerContentX();
        };

        this.handleCtaMotionPreference = () => {
          this.resetAllCtaScrollMotion();
        };

        this.handleCtaMotionPageRestore = () => {
          this.resetAllCtaScrollMotion();
        };

        this.mountCtaScrollMotion = () => {
          if (this.ctaMotionDestroyed || this.ctaMotionMounted) return;
          if (!window.LTLiquidGlass?.createMotion) return;

          this.ctaMotionMounted = true;

          if ('IntersectionObserver' in window) {
            this.ctaMotionObserver = new IntersectionObserver(
              (entries) => {
                this.ctaMotionVisibilityReady = true;
                const hadNoVisibleElements = this.visibleCtaMotionElements.size === 0;
                const enteredElements = [];

                entries.forEach((entry) => {
                  const element = entry.target;

                  if (entry.isIntersecting && entry.intersectionRatio > 0) {
                    if (!this.visibleCtaMotionElements.has(element)) {
                      enteredElements.push(element);
                    }
                    this.visibleCtaMotionElements.add(element);
                    return;
                  }

                  this.visibleCtaMotionElements.delete(element);
                  this.resetCtaMotionElement(element);
                });

                if (this.visibleCtaMotionElements.size === 0) {
                  this.resetAllCtaScrollMotion();
                  return;
                }

                if (hadNoVisibleElements) {
                  this.clearCtaMotionInput();
                  this.ctaMotionLastScrollY = this.getCtaPageScrollY();
                  this.ctaMotionLastScrollerX = this.getCtaScrollerContentX();
                }

                const now = performance.now();
                enteredElements.forEach((element) => {
                  this.initializeCtaMotionPathSample(element, now);
                });
              },
              { root: null, rootMargin: '160px 0px', threshold: 0 }
            );

            this.ctaMotionElements.forEach((element) => this.ctaMotionObserver.observe(element));
          }

          window.addEventListener('pageshow', this.handleCtaMotionPageRestore);
          document.addEventListener('visibilitychange', this.handleCtaMotionPageRestore);

          if (typeof this.glassMotionPreference.addEventListener === 'function') {
            this.glassMotionPreference.addEventListener('change', this.handleCtaMotionPreference);
          } else {
            this.glassMotionPreference.addListener(this.handleCtaMotionPreference);
          }
        };

        this.handleCtaMotionCoreLoad = () => this.mountCtaScrollMotion();
        this.retryCtaMotionCoreMount = () => {
          this.ctaMotionCoreRetryFrame = undefined;

          if (this.ctaMotionDestroyed || this.ctaMotionMounted) return;

          this.mountCtaScrollMotion();
          this.ctaMotionCoreRetryCount += 1;

          if (!this.ctaMotionMounted && this.ctaMotionCoreRetryCount < 180) {
            this.ctaMotionCoreRetryFrame = window.requestAnimationFrame(
              this.retryCtaMotionCoreMount
            );
          }
        };
        const owningSection = this.closest('.shopify-section');
        const coreScript =
          owningSection?.querySelector('script[data-lt-liquid-glass-core]') ||
          document.querySelector('script[data-lt-liquid-glass-core]');

        if (window.LTLiquidGlass?.createMotion) {
          this.mountCtaScrollMotion();
        } else if (coreScript) {
          this.ctaMotionCoreScript = coreScript;
          coreScript.addEventListener('load', this.handleCtaMotionCoreLoad, { once: true });
          this.ctaMotionCoreRetryFrame = window.requestAnimationFrame(
            this.retryCtaMotionCoreMount
          );
        }
      }

      cleanupCtaScrollMotion() {
        this.ctaMotionDestroyed = true;
        this.ctaMotionCoreScript?.removeEventListener('load', this.handleCtaMotionCoreLoad);
        window.removeEventListener('pageshow', this.handleCtaMotionPageRestore);
        document.removeEventListener('visibilitychange', this.handleCtaMotionPageRestore);

        if (typeof this.glassMotionPreference?.removeEventListener === 'function') {
          this.glassMotionPreference.removeEventListener('change', this.handleCtaMotionPreference);
        } else {
          this.glassMotionPreference?.removeListener(this.handleCtaMotionPreference);
        }

        this.ctaMotionObserver?.disconnect();

        if (this.ctaMotionFrame !== undefined) {
          window.cancelAnimationFrame(this.ctaMotionFrame);
          this.ctaMotionFrame = undefined;
        }

        if (this.ctaMotionCoreRetryFrame !== undefined) {
          window.cancelAnimationFrame(this.ctaMotionCoreRetryFrame);
          this.ctaMotionCoreRetryFrame = undefined;
        }

        this.ctaMotionControllers?.forEach((controller, element) => {
          controller.destroy();
          element.classList.remove('is-liquid-moving');
        });

        this.ctaMotionControllers?.clear();
        this.ctaMotionProfiles?.clear();
        this.visibleCtaMotionElements?.clear();
        this.ctaMotionPathHistory = [];
        this.ctaMotionElements = [];
        this.ctaMotionMounted = false;
      }

      scrollByCard(direction) {
        const card = this.scroller.querySelector('.mb-shop-by-category__card');
        if (!card) return;

        const styles = window.getComputedStyle(this.scroller);
        const gap = Number.parseFloat(styles.columnGap) || 0;
        const isRightToLeft = styles.direction === 'rtl';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const distance = card.getBoundingClientRect().width + gap;

        this.scroller.scrollBy({
          left: direction * distance * (isRightToLeft ? -1 : 1),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      updateControls() {
        this.updateNavigationPosition();

        const maximumScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const canScroll = maximumScroll > 2;

        this.controls.hidden = !canScroll;

        if (!canScroll) {
          this.previousButton.disabled = true;
          this.nextButton.disabled = true;
          return;
        }

        const currentScroll = Math.abs(this.scroller.scrollLeft);
        this.previousButton.disabled = currentScroll <= 2;
        this.nextButton.disabled = currentScroll >= maximumScroll - 2;
      }

      updateNavigationPosition() {
        const media = this.scroller.querySelector('.mb-shop-by-category__media');
        if (!media) return;

        const shellRectangle = this.shell.getBoundingClientRect();
        const mediaRectangle = media.getBoundingClientRect();
        const mediaCenter = mediaRectangle.top - shellRectangle.top + mediaRectangle.height / 2;

        this.controls.style.setProperty('--mb-category-navigation-top', `${mediaCenter}px`);
      }

      revealBlock(block) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        block?.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }

    if (!customElements.get('maya-category-slider')) {
      customElements.define('maya-category-slider', MayaCategorySlider);
    }

    if (!window.__mayaCategoryBlockSelectBound) {
      window.__mayaCategoryBlockSelectBound = true;
      document.addEventListener('shopify:block:select', (event) => {
        const slider = event.target.closest('maya-category-slider');
        if (slider && typeof slider.revealBlock === 'function') {
          slider.revealBlock(event.target);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-filter-toolbar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__newCollectionFilterBound) return;
    window.__newCollectionFilterBound = true;

    const OPEN_CLASS = 'new-collection-filter-open';
    const TAB_ANIMATION_MS = 430;
    const LIQUID_DRIVE_HOLD_MS = 100;
    const LIQUID_DRIVE_FADE_MS = 50;
    const LIQUID_SETTLE_BEFORE_NAV_MS = 400;
    const LIQUID_CORE_RETRY_LIMIT = 180;
    const reducedMotionQuery = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );
    const indicatorMotionStates = new WeakMap();
    const liveIndicatorMotionStates = new Set();
    let isOpen = window.__newCollectionFilterOpen === true;
    let resizeTimer = null;
    let tabAnimationLock = false;
    let nativeNavigationPending = false;
    let liquidCoreRetryFrame = null;
    let liquidCoreRetryCount = 0;

    const getBreakpoint = () => {
      const root = document.querySelector('[data-new-filter-toolbar-root]');
      if (!root) return 1000;
      return Number(root.dataset.breakpoint || 1000);
    };

    const syncUI = () => {
      const wrappers = document.querySelectorAll(
        '.collection-wrapper.new-collection-filter-layout'
      );
      const sidebars = document.querySelectorAll('[data-new-filter-sidebar]');
      const toolbarRoots = document.querySelectorAll(
        '[data-new-filter-toolbar-root]'
      );
      const desktop = window.innerWidth >= getBreakpoint();

      wrappers.forEach((wrapper) => {
        wrapper.classList.toggle(OPEN_CLASS, isOpen);
      });

      sidebars.forEach((sidebar) => {
        sidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      });

      toolbarRoots.forEach((root) => {
        const toggle = root.querySelector('[data-new-filter-toggle]');
        const toggleLabel = root.querySelector(
          '[data-new-filter-toggle-label]'
        );
        const openLabel = root.dataset.openLabel || 'Filter';
        const closeLabel = root.dataset.closeLabel || 'Hide filters';

        if (toggle) {
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }

        if (toggleLabel) {
          toggleLabel.textContent = isOpen ? closeLabel : openLabel;
        }
      });

      document.documentElement.classList.toggle(
        'new-filter-lock-scroll',
        !desktop && isOpen
      );

      document.documentElement.classList.toggle(
        'new-collection-filter-open-global',
        isOpen
      );
    };

    const setOpenState = (open) => {
      isOpen = open === true;
      window.__newCollectionFilterOpen = isOpen;
      syncUI();
    };

    setOpenState(isOpen);

    document.addEventListener(
      'lt:collection-navigation:close-drawer',
      () => setOpenState(false)
    );

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        if (target.closest('[data-new-filter-toggle]')) {
          setOpenState(!isOpen);
          return;
        }

        if (target.closest('[data-new-filter-close]')) {
          setOpenState(false);
        }
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpenState(false);
      }
    });

    window.addEventListener('resize', () => {
      syncUI();

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        updateAllCategoryIndicators(false);
      }, 120);
    });

    function getCategoryWrap(toolbarRoot) {
      return toolbarRoot.querySelector(
        '.new-collection-filter__categories'
      );
    }

    function getCategoryIndicator(toolbarRoot) {
      return toolbarRoot.querySelector(
        '.new-collection-filter__indicator'
      );
    }

    function clampNumber(value, minimum, maximum) {
      return Math.min(maximum, Math.max(minimum, value));
    }

    function getIndicatorMotionState(toolbarRoot) {
      const indicator = getCategoryIndicator(toolbarRoot);
      if (!indicator) return null;

      let motionState = indicatorMotionStates.get(indicator);
      if (motionState) return motionState;

      motionState = {
        toolbarRoot,
        indicator,
        surface: indicator.querySelector(
          '[data-lt-liquid-glass-surface]'
        ),
        liquidMotion: null,
        frame: null,
        hostAnimation: null,
        previousCenter: 0,
        targetCenter: 0,
        motionStartTime: 0,
        lastFrameTime: 0,
        destroyed: false,
      };

      indicatorMotionStates.set(indicator, motionState);
      liveIndicatorMotionStates.add(motionState);
      return motionState;
    }

    function ensureIndicatorLiquidMotion(motionState) {
      if (
        !motionState ||
        motionState.destroyed ||
        motionState.liquidMotion
      ) {
        return motionState?.liquidMotion || null;
      }

      if (
        !motionState.surface ||
        !window.LTLiquidGlass?.createMotion
      ) {
        return null;
      }

      motionState.liquidMotion = window.LTLiquidGlass.createMotion(
        motionState.indicator,
        {
          surface: motionState.surface,
          reducedMotionQuery,
          velocityFilterRate: 46,
          speedReference: 800,
          shapeStiffness: 900,
          shapeDamping: 42,
        }
      );

      return motionState.liquidMotion;
    }

    function mountAllIndicatorLiquidMotions() {
      if (!window.LTLiquidGlass?.createMotion) return false;

      liveIndicatorMotionStates.forEach((motionState) => {
        if (!motionState.indicator.isConnected) return;
        ensureIndicatorLiquidMotion(motionState);
      });

      return true;
    }

    function retryLiquidCoreMount() {
      liquidCoreRetryFrame = null;

      if (mountAllIndicatorLiquidMotions()) {
        liquidCoreRetryCount = 0;
        return;
      }

      liquidCoreRetryCount += 1;
      if (liquidCoreRetryCount >= LIQUID_CORE_RETRY_LIMIT) return;

      liquidCoreRetryFrame = window.requestAnimationFrame(
        retryLiquidCoreMount
      );
    }

    function scheduleLiquidCoreMount() {
      if (mountAllIndicatorLiquidMotions()) return;
      if (liquidCoreRetryFrame !== null) return;

      liquidCoreRetryCount = 0;
      liquidCoreRetryFrame = window.requestAnimationFrame(
        retryLiquidCoreMount
      );
    }

    function stopIndicatorMotionSampling(
      motionState,
      { resetLiquid = true, cancelHost = true } = {}
    ) {
      if (!motionState) return;

      if (motionState.frame !== null) {
        window.cancelAnimationFrame(motionState.frame);
        motionState.frame = null;
      }

      if (cancelHost && motionState.hostAnimation) {
        motionState.hostAnimation.cancel();
        motionState.hostAnimation = null;
      }

      motionState.lastFrameTime = 0;

      if (resetLiquid) {
        motionState.liquidMotion?.reset();
        motionState.surface?.style.removeProperty('transform-origin');
      }
    }

    function destroyIndicatorMotion(motionState) {
      if (!motionState || motionState.destroyed) return;

      stopIndicatorMotionSampling(motionState);
      motionState.liquidMotion?.destroy();
      motionState.liquidMotion = null;
      motionState.destroyed = true;
      indicatorMotionStates.delete(motionState.indicator);
      liveIndicatorMotionStates.delete(motionState);
    }

    function destroyDisconnectedIndicatorMotions() {
      liveIndicatorMotionStates.forEach((motionState) => {
        if (!motionState.indicator.isConnected) {
          destroyIndicatorMotion(motionState);
        }
      });
    }

    function destroyIndicatorMotionsWithin(scope) {
      liveIndicatorMotionStates.forEach((motionState) => {
        if (
          scope === motionState.toolbarRoot ||
          scope === motionState.indicator ||
          scope?.contains?.(motionState.toolbarRoot)
        ) {
          destroyIndicatorMotion(motionState);
        }
      });
    }

    function getIndicatorState(indicator) {
      return {
        x: Number(indicator.dataset.x || 6),
        width: Number(indicator.dataset.width || 0),
      };
    }

    function getRenderedIndicatorState(toolbarRoot, indicator) {
      const wrap = getCategoryWrap(toolbarRoot);

      if (!wrap || !indicator) {
        return getIndicatorState(indicator);
      }

      const wrapRect = wrap.getBoundingClientRect();
      const indicatorRect = indicator.getBoundingClientRect();

      return {
        x:
          indicatorRect.left -
          wrapRect.left +
          wrap.scrollLeft,
        width: indicatorRect.width,
        rect: indicatorRect,
      };
    }

    function getLinkState(toolbarRoot, link) {
      const wrap = getCategoryWrap(toolbarRoot);

      if (!wrap || !link) {
        return {
          x: 6,
          width: 0,
        };
      }

      const wrapRect = wrap.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();

      return {
        x: linkRect.left - wrapRect.left + wrap.scrollLeft,
        width: linkRect.width,
      };
    }

    function writeIndicatorState(toolbarRoot, state) {
      const wrap = getCategoryWrap(toolbarRoot);
      const indicator = getCategoryIndicator(toolbarRoot);

      if (!wrap || !indicator) return;

      indicator.dataset.x = String(state.x);
      indicator.dataset.width = String(state.width);
      indicator.style.transform = `translate3d(${state.x}px, 0, 0)`;
      indicator.style.width = `${state.width}px`;

      wrap.classList.add('is-indicator-ready');
    }

    function setIndicatorState(toolbarRoot, state) {
      const motionState = getIndicatorMotionState(toolbarRoot);

      if (motionState) {
        stopIndicatorMotionSampling(motionState);
        motionState.previousCenter = state.x + state.width / 2;
        motionState.targetCenter = motionState.previousCenter;
        ensureIndicatorLiquidMotion(motionState)?.reset();
      }

      writeIndicatorState(toolbarRoot, state);
    }

    function getIndicatorEdgeFactor(
      motionState,
      indicatorRect
    ) {
      const toolbarRoot = motionState.toolbarRoot;
      const menu = toolbarRoot.querySelector(
        '.new-collection-filter__menu'
      );

      if (!menu || !indicatorRect) return 1;

      const menuRect = menu.getBoundingClientRect();
      const leftClearance = Math.max(
        0,
        indicatorRect.left - menuRect.left
      );
      const rightClearance = Math.max(
        0,
        menuRect.right - indicatorRect.right
      );
      const edgeClearance = Math.max(
        0,
        Math.min(leftClearance, rightClearance)
      );
      const leftInfluence =
        1 - clampNumber((leftClearance - 4) / 32, 0, 1);
      const rightInfluence =
        1 - clampNumber((rightClearance - 4) / 32, 0, 1);
      const originX = clampNumber(
        50 - leftInfluence * 50 + rightInfluence * 50,
        0,
        100
      );

      motionState.surface?.style.setProperty(
        'transform-origin',
        `${originX.toFixed(2)}% center`
      );

      return clampNumber(edgeClearance / 28, 0.72, 1);
    }

    function runIndicatorMotionSample(motionState, now) {
      motionState.frame = null;

      if (
        motionState.destroyed ||
        !motionState.indicator.isConnected
      ) {
        destroyIndicatorMotion(motionState);
        return;
      }

      if (reducedMotionQuery.matches || document.hidden) {
        stopIndicatorMotionSampling(motionState);
        return;
      }

      const elapsedSeconds = clampNumber(
        (now -
          (motionState.lastFrameTime || now - 1000 / 60)) /
          1000,
        1 / 240,
        0.034
      );
      motionState.lastFrameTime = now;

      const renderedState = getRenderedIndicatorState(
        motionState.toolbarRoot,
        motionState.indicator
      );
      const currentCenter =
        renderedState.x + renderedState.width / 2;
      const motionAge = now - motionState.motionStartTime;
      const driveFactor = clampNumber(
        1 -
          Math.max(0, motionAge - LIQUID_DRIVE_HOLD_MS) /
            LIQUID_DRIVE_FADE_MS,
        0,
        1
      );
      const edgeFactor = getIndicatorEdgeFactor(
        motionState,
        renderedState.rect
      );
      const liquidMotion = ensureIndicatorLiquidMotion(
        motionState
      );
      const result = liquidMotion?.update({
        elapsedSeconds,
        movedX:
          (currentCenter - motionState.previousCenter) *
          edgeFactor *
          driveFactor,
        movedY: 0,
        targetDistance:
          Math.abs(motionState.targetCenter - currentCenter) *
          edgeFactor *
          driveFactor,
        pointerIsIdle:
          motionAge > LIQUID_DRIVE_HOLD_MS,
      });

      motionState.previousCenter = currentCenter;

      const hostIsAnimating =
        motionState.hostAnimation &&
        (motionState.hostAnimation.playState === 'running' ||
          motionState.hostAnimation.playState === 'pending');

      if (
        motionAge >= LIQUID_SETTLE_BEFORE_NAV_MS ||
        (result?.settled && driveFactor === 0)
      ) {
        liquidMotion?.reset();
        motionState.surface?.style.removeProperty('transform-origin');
        motionState.lastFrameTime = 0;
        return;
      }

      if (!hostIsAnimating && !result) {
        motionState.lastFrameTime = 0;
        return;
      }

      motionState.frame = window.requestAnimationFrame((frameNow) => {
        runIndicatorMotionSample(motionState, frameNow);
      });
    }

    function startIndicatorMotionSampling(motionState) {
      if (!motionState || motionState.frame !== null) return;

      motionState.lastFrameTime = performance.now();
      motionState.frame = window.requestAnimationFrame((now) => {
        runIndicatorMotionSample(motionState, now);
      });
    }

    function animateIndicatorTo(toolbarRoot, link) {
      const indicator = getCategoryIndicator(toolbarRoot);

      if (!indicator || !link) return;

      const motionState = getIndicatorMotionState(toolbarRoot);
      const from = getRenderedIndicatorState(
        toolbarRoot,
        indicator
      );
      const to = getLinkState(toolbarRoot, link);

      if (reducedMotionQuery.matches) {
        setIndicatorState(toolbarRoot, to);
        return;
      }

      stopIndicatorMotionSampling(motionState, {
        resetLiquid: false,
      });

      writeIndicatorState(toolbarRoot, to);

      const hostAnimation = indicator.animate(
        [
          {
            transform: `translate3d(${from.x}px, 0, 0)`,
            width: `${from.width}px`,
          },
          {
            transform: `translate3d(${to.x}px, 0, 0)`,
            width: `${to.width}px`,
          },
        ],
        {
          duration: TAB_ANIMATION_MS,
          easing: 'cubic-bezier(0.28, 0.11, 0.32, 1)',
          fill: 'none',
        }
      );

      motionState.hostAnimation = hostAnimation;
      motionState.previousCenter = from.x + from.width / 2;
      motionState.targetCenter = to.x + to.width / 2;
      motionState.motionStartTime = performance.now();

      ensureIndicatorLiquidMotion(motionState);
      startIndicatorMotionSampling(motionState);
    }

    function updateAllCategoryIndicators(animate = true) {
      document
        .querySelectorAll('[data-new-filter-toolbar-root]')
        .forEach((toolbarRoot) => {
          const active = toolbarRoot.querySelector(
            '.new-collection-filter__link.is-active'
          );

          if (!active) return;

          if (animate) {
            animateIndicatorTo(toolbarRoot, active);
          } else {
            setIndicatorState(
              toolbarRoot,
              getLinkState(toolbarRoot, active)
            );
          }
        });
    }

    function setActiveVisual(toolbarRoot, link, animate = true) {
      toolbarRoot
        .querySelectorAll('.new-collection-filter__link')
        .forEach((tab) => {
          tab.classList.toggle('is-active', tab === link);
        });

      if (animate) {
        animateIndicatorTo(toolbarRoot, link);
      } else {
        setIndicatorState(
          toolbarRoot,
          getLinkState(toolbarRoot, link)
        );
      }
    }

    function handleCategoryClick(event) {
      const link =
        event.target instanceof Element
          ? event.target.closest('[data-collection-category-link]')
          : null;

      if (!link) return;

      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        link.hasAttribute('download') ||
        (link.target && link.target !== '_self')
      ) {
        return;
      }

      const toolbarRoot = link.closest(
        '[data-new-filter-toolbar-root]'
      );

      const categories = link.closest(
        '.new-collection-filter__categories'
      );

      if (
        !toolbarRoot ||
        !categories ||
        link.classList.contains('is-disabled')
      ) {
        return;
      }

      const destination = link.href;

      if (!destination) return;

      const currentUrl = new URL(window.location.href);
      const destinationUrl = new URL(
        destination,
        window.location.origin
      );

      if (destinationUrl.origin !== currentUrl.origin) return;

      if (
        currentUrl.pathname === destinationUrl.pathname &&
        currentUrl.search === destinationUrl.search
      ) {
        event.preventDefault();

        if (
          tabAnimationLock &&
          !nativeNavigationPending &&
          window.LTCollectionNavigation?.cancelPending?.()
        ) {
          setActiveVisual(toolbarRoot, link, true);
        }

        return;
      }

      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      const navigationRequest = {
        accepted: false,
        toolbarRoot,
        link,
        destination: destinationUrl.toString(),
        sourceTemplateKey:
          toolbarRoot.dataset.collectionTemplateKey,
        destinationTemplateKey:
          link.dataset.collectionTemplateKey,
        label: link.textContent.trim(),
        startedAt: performance.now(),
        minimumHandoff: TAB_ANIMATION_MS,
      };

      const canUseSameTemplateNavigation =
        window.LTCollectionNavigation?.canNavigate?.(
          navigationRequest
        ) === true;

      if (
        tabAnimationLock &&
        !nativeNavigationPending &&
        !canUseSameTemplateNavigation
      ) {
        window.LTCollectionNavigation?.cancelPending?.(true);
      }

      if (
        tabAnimationLock &&
        (nativeNavigationPending || !canUseSameTemplateNavigation)
      ) {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      const wasAnimationLocked = tabAnimationLock;
      tabAnimationLock = true;
      setActiveVisual(toolbarRoot, link, true);

      document.dispatchEvent(
        new CustomEvent(
          'lt:collection-navigation:request',
          { detail: navigationRequest }
        )
      );

      if (navigationRequest.accepted) return;
      if (wasAnimationLocked) return;

      nativeNavigationPending = true;

      window.setTimeout(() => {
        link.setAttribute(
          'data-view-transition-type',
          'collection-navigation'
        );
        link.setAttribute(
          'data-view-transition-triggered',
          'true'
        );
        window.location.href = destination;
      }, TAB_ANIMATION_MS);
    }

    function initCategoryTabs(toolbarRoot) {
      if (!toolbarRoot.dataset.categoryTabsBound) {
        toolbarRoot.dataset.categoryTabsBound = 'true';

        const categories = toolbarRoot.querySelector(
          '.new-collection-filter__categories'
        );

        if (categories) {
          categories.addEventListener(
            'click',
            handleCategoryClick
          );
        }
      }

      const active = toolbarRoot.querySelector(
        '.new-collection-filter__link.is-active'
      );

      if (active) {
        setIndicatorState(
          toolbarRoot,
          getLinkState(toolbarRoot, active)
        );
      }
    }

    function triggerFilterUpdate(input) {
      if (input) {
        input.dispatchEvent(
          new Event('change', {
            bubbles: true,
          })
        );

        return;
      }

      const form = document.getElementById(
        'FacetFiltersForm--new-collection-filter-desktop'
      );

      const facetsComponent = form
        ? form.closest('facets-form-component')
        : null;

      if (
        facetsComponent &&
        typeof facetsComponent.updateFilters === 'function'
      ) {
        facetsComponent.updateFilters();
        return;
      }

      if (form) {
        form.dispatchEvent(
          new Event('change', {
            bubbles: true,
          })
        );
      }
    }

    function initClearButton() {
      document
        .querySelectorAll(
          '.new-collection-filter__clear-selected'
        )
        .forEach((button) => {
          button.removeEventListener(
            'click',
            clearFiltersHandler
          );

          button.addEventListener(
            'click',
            clearFiltersHandler
          );
        });
    }

    function clearFiltersHandler(event) {
      event.preventDefault();

      const checkedFilters = document.querySelectorAll(
        'input[type="checkbox"][name^="filter."]:checked'
      );

      let changedInput = null;

      checkedFilters.forEach((cb) => {
        cb.checked = false;
        changedInput = cb;
      });

      triggerFilterUpdate(changedInput);

      window.requestAnimationFrame(() => {
        updateAllCategoryIndicators(false);
      });
    }

    function getSortLabel(input) {
      if (!input) return '';

      if (input instanceof HTMLSelectElement) {
        return (
          input.selectedOptions[0]?.textContent.trim() || ''
        );
      }

      return (
        input.dataset.optionName ||
        input
          .closest('.sorting-filter__option')
          ?.querySelector('.sorting-filter__label')
          ?.textContent.trim() ||
        ''
      );
    }

    function syncSortVisual(input) {
      const sortRoot = input.closest(
        '.new-collection-filter__sort'
      );

      const label = getSortLabel(input);

      if (!sortRoot || !label) return;

      const status = sortRoot.querySelector('.facets__status');
      const select = sortRoot.querySelector(
        'select[name="sort_by"]'
      );

      const checkedInput = sortRoot.querySelector(
        'input[name="sort_by"]:checked'
      );

      if (status) {
        status.textContent = label;
      }

      if (select) {
        select.value = input.value;
      }

      sortRoot
        .querySelectorAll('.sorting-filter__option')
        .forEach((option) => {
          const optionInput = option.querySelector(
            'input[name="sort_by"]'
          );

          const isSelected = optionInput === checkedInput;

          option.setAttribute(
            'aria-selected',
            isSelected ? 'true' : 'false'
          );

          option.setAttribute(
            'tabindex',
            isSelected ? '0' : '-1'
          );
        });
    }

    function closeSortDropdown(input) {
      const details = input.closest('details');

      if (!details) return;

      window.setTimeout(() => {
        details.removeAttribute('open');

        const summary = details.querySelector('summary');

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      }, 150);
    }

    function initSorting() {
      document
        .querySelectorAll(
          'input[name="sort_by"], select[name="sort_by"]'
        )
        .forEach((input) => {
          input.removeEventListener(
            'change',
            sortChangeHandler
          );

          input.addEventListener(
            'change',
            sortChangeHandler
          );
        });
    }

    function sortChangeHandler(event) {
      const input = event.target;

      if (!(input instanceof HTMLElement) || !input.isConnected) {
        return;
      }

      syncSortVisual(input);

      window.requestAnimationFrame(() => {
        if (input.isConnected) closeSortDropdown(input);
      });
    }

    function reinitAll() {
      destroyDisconnectedIndicatorMotions();
      observeCollectionWrapper();

      document
        .querySelectorAll('[data-new-filter-toolbar-root]')
        .forEach(initCategoryTabs);

      initClearButton();
      initSorting();
      syncUI();

      window.requestAnimationFrame(() => {
        updateAllCategoryIndicators(false);
        scheduleLiquidCoreMount();
      });
    }

    document.addEventListener(
      'facet:updated',
      reinitAll
    );

    document.addEventListener(
      'ajaxSuccess',
      reinitAll
    );

    document.addEventListener(
      'lt:collection-navigation:complete',
      () => {
        tabAnimationLock = false;
        nativeNavigationPending = false;
      }
    );

    document.addEventListener(
      'lt:collection-navigation:visual-target',
      (event) => {
        const toolbarRoot = event.detail?.toolbarRoot;
        const link = event.detail?.link;

        if (
          toolbarRoot instanceof HTMLElement &&
          link instanceof HTMLElement &&
          toolbarRoot.isConnected &&
          link.isConnected
        ) {
          setActiveVisual(toolbarRoot, link, true);
        }
      }
    );

    document.addEventListener(
      'shopify:section:load',
      reinitAll
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        if (event.target instanceof Element) {
          destroyIndicatorMotionsWithin(event.target);
        }
      }
    );

    window.addEventListener('pageshow', () => {
      tabAnimationLock = false;
      nativeNavigationPending = false;

      updateAllCategoryIndicators(false);

      document
        .querySelectorAll(
          '[data-collection-category-link][data-view-transition-triggered]'
        )
        .forEach((link) => {
          link.removeAttribute('data-view-transition-triggered');
          link.removeAttribute('data-view-transition-type');
        });
    });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) return;

      liveIndicatorMotionStates.forEach((motionState) => {
        stopIndicatorMotionSampling(motionState);
      });
    });

    const handleReducedMotionChange = () => {
      if (!reducedMotionQuery.matches) return;
      updateAllCategoryIndicators(false);
    };

    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener(
        'change',
        handleReducedMotionChange
      );
    } else {
      reducedMotionQuery.addListener(handleReducedMotionChange);
    }

    const liquidCoreScript = document.querySelector(
      'script[data-lt-liquid-glass-core]'
    );

    liquidCoreScript?.addEventListener(
      'load',
      mountAllIndicatorLiquidMotions,
      { once: true }
    );

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        updateAllCategoryIndicators(false);
      });
    }

    const observer = new MutationObserver(() => {
      clearTimeout(window.__facetUpdateTimeout);

      window.__facetUpdateTimeout = setTimeout(
        reinitAll,
        100
      );
    });

    let observedCollectionWrapper = null;

    function observeCollectionWrapper() {
      const collectionWrapper = document.querySelector(
        '.collection-wrapper.new-collection-filter-layout'
      );

      if (collectionWrapper === observedCollectionWrapper) return;

      observer.disconnect();
      observedCollectionWrapper = collectionWrapper;

      if (collectionWrapper) {
        observer.observe(collectionWrapper, {
          childList: true,
          subtree: true,
        });
      }
    }

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        observeCollectionWrapper();
        reinitAll();
      }
    );

    if (document.readyState !== 'loading') {
      reinitAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-new-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.__mbPdpRecommendationsBound) {
      window.__mbPdpRecommendationsBound = true;

      document.addEventListener('click', (event) => {
        const swatch = event.target.closest('.mb-product-recommendation-section [data-mb-cowboy-swatch]');
        if (!swatch) return;

        const card = swatch.closest('[data-mb-cowboy-card]');
        if (!card) return;

        const image = card.querySelector('[data-mb-cowboy-card-image]');
        const link = card.querySelector('[data-mb-cowboy-card-link]');
        const salePrice = card.querySelector('[data-mb-cowboy-sale-price]');
        const comparePrice = card.querySelector('[data-mb-cowboy-compare-price]');

        const imageUrl = swatch.dataset.image;
        const variantUrl = swatch.dataset.url;

        event.preventDefault();
        event.stopPropagation();

        card.querySelectorAll('[data-mb-cowboy-swatch]').forEach((button) => {
          button.classList.toggle('is-active', button === swatch);
        });

        if (link && variantUrl) {
          link.href = variantUrl;
        }

        if (salePrice && swatch.dataset.price) {
          salePrice.textContent = swatch.dataset.price;
        }

        if (comparePrice) {
          if (swatch.dataset.comparePrice) {
            comparePrice.textContent = swatch.dataset.comparePrice;
            comparePrice.hidden = false;
          } else {
            comparePrice.textContent = '';
            comparePrice.hidden = true;
          }
        }

        if (image && imageUrl) {
          card.classList.add('is-changing');

          const preload = new Image();

          preload.onload = () => {
            image.src = imageUrl;
            image.removeAttribute('srcset');
            card.classList.remove('is-changing');
          };

          preload.onerror = () => {
            card.classList.remove('is-changing');
          };

          preload.src = imageUrl;
        }
      });
    }

    document.addEventListener('recommendations:loaded', (e) => {
      const recommendationsRoot = e.target?.closest?.('product-recommendations') || e.target;
      const recommendationSwiper = recommendationsRoot?.querySelector?.('.mb-pro-recommendations-swiper');

      if (!recommendationSwiper || recommendationSwiper.classList.contains('swiper-initialized')) return;

      new Swiper(recommendationSwiper, {
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 650,
        loop: false,
        autoplay: false,
        pagination: false,
        watchOverflow: true,
        resistanceRatio: 0.65,

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
            speed: 650,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 32,
            speed: 700,
          },
        },

        navigation: {
          nextEl: recommendationsRoot.querySelector('.swiper-button-next.mb-pro-top-arrows'),
          prevEl: recommendationsRoot.querySelector('.swiper-button-prev.mb-pro-top-arrows'),
        },
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
